export const AdminActionName = {
	regen_out_doc: 'regen_out_doc',
	try_gen_out_doc: 'try_gen_out_doc',
	regen_out_doc_with_empty_data: "regen_out_doc_with_empty_data",
	run_task: "run_task",
};
